"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactSizeme = require("react-sizeme");

var _memoizeOne2 = _interopRequireDefault(require("memoize-one"));

var _IconRadioButton = _interopRequireDefault(require("./IconRadioButton"));

require("../styles/_icon-radio-buttons.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var SMALL_THRESHOLD = 275;
var onSelect = (0, _memoizeOne2.default)(function (action, index) {
  return function () {
    action(index);
  };
});

function IconRadioButtons(_ref) {
  var options = _ref.options,
      onChange = _ref.onChange,
      selectedIndex = _ref.selectedIndex,
      canUpdateVideo = _ref.canUpdateVideo;
  return (/*#__PURE__*/_react.default.createElement(_reactSizeme.SizeMe, null, function (_ref2) {
      var size = _ref2.size;
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('icon-radio-buttons', {
            'icon-radio-buttons--small': size.width < SMALL_THRESHOLD
          })
        }, options.map(function (_ref3, index) {
          var icon = _ref3.icon,
              label = _ref3.label;
          return (/*#__PURE__*/_react.default.createElement(_IconRadioButton.default, {
              key: label,
              icon: icon,
              label: label,
              onSelect: onSelect(onChange, index),
              selected: selectedIndex === index,
              canUpdateVideo: canUpdateVideo
            })
          );
        }))
      );
    })
  );
}

var _default = (0, _react.memo)(IconRadioButtons);

exports.default = _default;